import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import MainFeature1 from "components/features/TwoColWithButton.js";
// import MainFeature2 from "components/features/TwoColSingleFeatureWithStats.js";
// import MainFeature3 from "components/features/TwoColSingleFeatureWithStats2.js";
import Features from "components/features/ThreeColSimple.js";
import FeaturesFullWith from "components/features/ThreeColSimpleFullWidth.js";
// import Features from "components/features/ThreeColWithSideImage.js";
import TeamCardGrid from "components/cards/ProfileThreeColGrid.js";

import SupportIconImage from "images/support-icon.svg";
import ShieldIconImage from "images/shield-icon.svg";
import CustomerLoveIconImage from "images/simple-icon.svg";
import { Helmet } from "react-helmet-async";

const Subheading = tw.span`uppercase tracking-wider text-sm`;
export default () => {
  return (
    <>
    <Helmet>
      <title>About | Placement & Business Services Ltd</title>
      <meta
        name="description"
        content="Learn more about My Company, our mission, values, and team."
      />

      <link rel="canonical" href="https://www.pbslja.com/about" />

      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "About",
          "url": "https://www.pbslja.com/about",
          "description": "Learn more about Placement and Business Services Ltd., our mission, values, and the services we provide across Jamaica.",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.pbslja.com/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "About",
                "item": "https://www.pbslja.com/about"
              }
            ]
          }
        })}
      </script>
    </Helmet>
    <AnimationRevealPage>
      <Header />
      <MainFeature1
        subheading={<Subheading>About PBS</Subheading>}
        heading="Your Partner in Personalized HR Services"
        buttonRounded={false}
        description="PBS is a leading provider of personalized HR services, dedicated to helping businesses thrive by managing 
        their most valuable asset - their people. Our team of experts is committed to delivering tailored solutions that meet 
        the unique needs of each client, ensuring compliance, efficiency, and employee satisfaction."
        primaryButtonText="See Portfolio"
        primaryButtonUrl="/services"
        imageSrc="https://bconnect.com.bd/wp-content/uploads/2020/08/HR-Services.jpg"
      />
      <MainFeature1
        subheading={<Subheading>Our Mission</Subheading>}
        heading="Providing Workforce Solutions"
        buttonRounded={false}
        primaryButtonText="Contact Us"
        primaryButtonUrl="/contact"
        description="We empower businesses by connecting them with exceptional talent and a range of support services to 
        handle the complexities of workforce administration with accuracy, integrity and care."
        imageSrc="https://dillanoblake.sirv.com/Images/Gemini_Generated_Image_50xom550xom550xo.png"
        textOnLeft={false}
      />
      <MainFeature1
        subheading={<Subheading>Our Motto</Subheading>}
        heading="Integrity dictates every action"
        buttonRounded={false}
        primaryButtonText="Contact Us"
        primaryButtonUrl="/contact"
        description="Integrity, total dedication and commitment to our core functions is evidenced by the 
        fact that much of our business results from the referrals of satisfied customers."
        imageSrc="https://images.unsplash.com/photo-1641891847722-7ca2a0df0879?q=80&w=1374&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      />
      {/* <Features
        subheading={<Subheading></Subheading>}
        heading="Our Objective"
        description="Our objective is to build on our strengths to overcome our weakness, while exploring
our opportunities and eradicate our threats, to ensure that PBS continues to be a
leader in our industry."
        cards={[
          {
            imageSrc: SupportIconImage,
            title: "24/7 Support",
            description: "Lorem ipsum donor amet siti ceali placeholder text alipiscing elit sed do eiusmod temport"
          },
          {
            imageSrc: ShieldIconImage,
            title: "Strong Teams",
            description: "Lorem ipsum donor amet siti ceali placeholder text alipiscing elit sed do eiusmod temport"
          },
          {
            imageSrc: CustomerLoveIconImage,
            title: "Customer Satisfaction",
            description: "Lorem ipsum donor amet siti ceali placeholder text alipiscing elit sed do eiusmod temport"
          },
        ]}
        linkText=""
      /> */}
      <FeaturesFullWith
        subheading={<Subheading></Subheading>}
        heading="Our Founder and Mentor"
        description={
          <>
          Here at PBS we owe our professional legacy to the late Mrs Irel Payne, a pioneer and stalwart in Jamaica’s business community, who
          enjoyed a storied business career.
          <br /><br />
          As our founder, CEO and mentor, Mrs Payne was the driving engine and catalyst for our
          many innovations in the marketplace, keeping us directed towards our ever-continuing
          goal and practice of “integrity in action.” It is a mantra we continue to hold dear as we
          strive every day to service our clientele and staff with an ongoing commitment to
          excellence.
          <br /><br />
          Today, we are honored to practice Mrs. Payne’s stated philosophy: “a willingness, ability, and capacity to adapt
          to changing times and the demands in the marketplace.” (Business Suite Magazine) As you conduct business with
          us, we invite you to join us on our mutual journey towards excellence, achievement, and
          accomplishment in today’s ever changing business environment!
          </>
        }
      />
      {/* <TeamCardGrid 
        subheading={<Subheading>Our Team</Subheading>}
      /> */}
      <Footer />
    </AnimationRevealPage>
    </>
  );
};
